<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<div [ngSwitch]="processoStatus">
  <div *ngSwitchDefault>
    <ng-container [ngTemplateOutlet]="iniciarProcesso"></ng-container>
  </div>

  <app-autenticacao-manual-em-andamento
    *ngSwitchCase="STATUS.AUTENTICACAO_MANUAL"
  ></app-autenticacao-manual-em-andamento>

  <app-autenticacao-realizada
    *ngSwitchCase="STATUS.REALIZADO"
  ></app-autenticacao-realizada>
</div>

<ng-template #iniciarProcesso>
  <div class="modal-body text-center">
    <span class="icon warning icone-laranja"></span>
    <p>
      <strong>Verifique </strong>se o cliente
      <strong>realizou o processo da biometria</strong> em seu celular.
    </p>
    <p>
      <strong class="text-danger"
        >Lembre-se que esta etapa é obrigatória e não será possível formalizar a
        proposta sem a autenticação do cliente.</strong
      >
    </p>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-full-orange"
      [disabled]="desabilitarBotao"
      (click)="verificarStatusBiometria()"
    >
      Verificar status da Biometria
      <ng-container *ngIf="desabilitarBotao">em {{ timeLeft }}s</ng-container>
      <span class="fa fa-arrow-right"></span>
    </button>
  </div>
</ng-template>
